"use strict";

$(document).ready(function () {
  if ($('body#order-detail').length > 0) {
    select2Init();

    if ($('.show-more-box .show-more').length > 0) {
      $('.show-more-box .show-more').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var thisClick = $(this);
        var box = thisClick.parents('.show-more-box');
        var holder = thisClick.parents('.box.messages');
        var collapse = holder.find('.collapse');
        collapse.slideDown('slow', function () {
          box.slideUp(200);
        });
      });
    }
  }
});

function select2Init() {
  $('.order-message-form #id_product_msg').select2({
    minimumResultsForSearch: -1
  });
}